import axiosInstance from "../../../api/axiosInstance";

export const fetchUserImagesAPI = async () => {
  const imagesList = await axiosInstance.get("images/get-all-user-images");

  return imagesList.data;
};

export const uploadUserImagesAPI = async (imageData) => {
  const uploadedImage = await axiosInstance.post(
    "images/upload-image",
    imageData
  );

  return uploadedImage.data;
};

export const deleteUserImageAPI = async (id) => {
  const deleteImageId = await axiosInstance.delete(`images/delete-image/${id}`);

  return deleteImageId.data;
};
